import { useEffect } from "react";

const BASE = "https://www.steckaviationllc.com";
const DEFAULT_IMG = `${BASE}/images/og-steck-aviation.jpg`;
const SITE_NAME = "Steck Aviation";

/**
 * Drop-in per-page head manager. No external package needed.
 * Patches existing tags in place and restores them on unmount
 * so SPA navigation stays clean.
 */
const SEO = ({ title, description, image, type = "website", schema }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = SITE_NAME;

    const created  = [];   // elements we injected—removed on cleanup
    const restored = [];   // elements we mutated—content restored on cleanup

    const meta = (attr, key, val) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (el) {
        restored.push({ el, prev: el.getAttribute("content") });
      } else {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        created.push(el);
      }
      el.setAttribute("content", val);
    };

    const img = image ? `${BASE}${image}` : DEFAULT_IMG;

    meta("name",     "description",         description);
    meta("property", "og:title",            title);
    meta("property", "og:description",      description);
    meta("property", "og:type",             type);
    meta("property", "og:image",            img);
    meta("property", "og:url",              window.location.href);
    meta("property", "og:site_name",        SITE_NAME);
    meta("name",     "twitter:card",        "summary_large_image");
    meta("name",     "twitter:title",       title);
    meta("name",     "twitter:description", description);
    meta("name",     "twitter:image",       img);

    let ldEl = null;
    if (schema) {
      ldEl = document.createElement("script");
      ldEl.type = "application/ld+json";
      ldEl.textContent = JSON.stringify(schema);
      document.head.appendChild(ldEl);
    }

    return () => {
      document.title = SITE_NAME;
      created.forEach(el => el.remove());
      restored.forEach(({ el, prev }) => el.setAttribute("content", prev));
      if (ldEl) ldEl.remove();
    };
  }, [title, description, image, type, schema]);

  return null;
};

export default SEO;
